module.exports = __webpack_public_path__ + "static/media/2v2-chaos-golf-step1.291a663d.png";